import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { InternalTransferListViewModel } from "../internalTransferList/internalTransferList-viewModel";
import  { InternalTransferDetailView } from "./internalTransferDetail-view"

export class InternalTransferDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: InternalTransferListViewModel, id: string) {
        super(parentViewModel);
        this._typedParent = parentViewModel;
        this.transferId = id;
        this.load();

        this.sourceLineItems = ObservableArray.create<lineItem>();
        this.destinationLineItems = ObservableArray.create<lineItem>();
    }
    closePopup(resultCode?: string) {
        this._typedParent.isShowingPopup = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new InternalTransferDetailView();
    }
    public getTypeId(): string {
        return "VM-D6B235C4-EF22-40E8-881E-F16D9EC6C365"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set sourceLineItems(v: ObservableArray<lineItem>) { this._sourceLineItems = v; } public get sourceLineItems(): ObservableArray<lineItem> { return this._sourceLineItems;} private _sourceLineItems: ObservableArray<lineItem>;
    public set destinationLineItems(v: ObservableArray<lineItem>) { this._destinationLineItems = v; } public get destinationLineItems(): ObservableArray<lineItem> { return this._destinationLineItems;} private _destinationLineItems: ObservableArray<lineItem>;
    public set transferType(v: string) { this._transferType = v; } public get transferType(): string { return this._transferType;} private _transferType: string;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId;} private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName;} private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId;} private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName;} private _toWarehouseName: string;
    public set transferId(v: string) { this._transferId = v; } public get transferId(): string { return this._transferId;} private _transferId: string;
    public set orderCode(v: number) { this._orderCode = v; } public get orderCode(): number { return this._orderCode;} private _orderCode: number;
    public set issueTime(v: moment.Moment) { this._issueTime = v; } public get issueTime(): moment.Moment { return this._issueTime;} private _issueTime: moment.Moment;
    public set orderTime(v: moment.Moment) { this._orderTime = v; } public get orderTime(): moment.Moment { return this._orderTime;} private _orderTime: moment.Moment;
    public set receiptTime(v: moment.Moment) { this._receiptTime = v; } public get receiptTime(): moment.Moment { return this._receiptTime;} private _receiptTime: moment.Moment;
    public set receiptCode(v: string) { this._receiptCode = v; } public get receiptCode(): string { return this._receiptCode;} private _receiptCode: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    
    private _typedParent : InternalTransferListViewModel;

    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseTransferServices/GetInternalTransferInfo',{
                Id:this.transferId,
            });
            this.orderCode = result.OrderCode;
            this.transferType = result.TransferType;
            this.issueTime = moment.utc(result.IssueTime);
            this.orderTime = result.OrderTime==null ? null : moment.utc(result.OrderTime);
            this.receiptTime = result.ReceiptTime==null ? null : moment.utc(result.ReceiptTime);
            this.fromWarehouseId = result.FromWarehouseId;
            this.fromWarehouseName = result.FromWarehouseName;
            this.toWarehouseId = result.ToWarehouseId;
            this.toWarehouseName = result.ToWarehouseName;
            this.receiptCode = result.ReceiptCode;
            this.comment = result.Comment;
            this.sourceLineItems.update(...result.OrderProducts.map((q,i)=>{
                let r = new lineItem(this);
                r.index = i+1;
                r.productCarModel = q.ProductCarModel;
                r.productCode = q.ProductCode;
                r.productName = q.ProductName;
                r.productUnit = q.UnitName;
                r.amount = q.Amount;
                return r;
            }));
            this.destinationLineItems.update(...result.ReceiptProducts.map((q,i)=>{
                let r = new lineItem(this);
                r.index = i+1;
                r.productCarModel = q.ProductCarModel;
                r.productCode = q.ProductCode;
                r.productName = q.ProductName;
                r.productUnit = q.UnitName;
                r.amount = q.Amount;
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class lineItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InternalTransferDetailViewModel) {
        super(parent);
        this._typedParent = parent;   
    }
    private _typedParent:InternalTransferDetailViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productUnit(v: string) { this._productUnit = v; } public get productUnit(): string { return this._productUnit;} private _productUnit: string;
    public set amount(v: number) { this._amount =v; } public get amount(): number { return this._amount;} private _amount: number;
    
}
